import { Injectable } from '@angular/core';
import { SelectedPerson } from './_interfaces_/selected-person.interface';
import { SelectedPersonMapped } from './_interfaces_/selected-person.mapped.interface';

@Injectable({
  providedIn: 'root',
})
export class SelectedPersonMapperService {
  constructor() {}

  mapSelectedPerson(selectedPerson: SelectedPerson): SelectedPersonMapped {
    return {
      firstName: selectedPerson.firstName,
      lastName: selectedPerson.lastName,
      dateOfBirth: selectedPerson.dateOfBirth,
      genderType: selectedPerson.genderType,
    };
  }
}
